import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '../services/alert/alert.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage-angular';

@Injectable()
export class AlertInterceptor implements HttpInterceptor {
  constructor(
    private alerts: AlertService,
    private router: Router,
    private storate: Storage
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.error?.error) {
          this.alerts.setAlert({
            type: 'danger',
            header: 'Error',
            message: error?.error?.error || 'Error de Servicio!',
          });
        }
        if (error.status === 401) {
          this.storate.clear().finally(() => this.router.navigate(['login']));
        }
        return throwError(error);
      })
    );
  }
}
